import React from 'react';

import { Checkbox, type CheckboxChangeEvent, Flex } from 'antd-v5';
import { FormattedMessage } from 'react-intl';
import { Text } from 'scouting-ui/lib';

import type { SubUnitType } from '@appTypes/esb';

import { visibilityFields } from '../../../../constants';
import styles from '../PackRosterFilterCard.less';

interface VisibilitySectionProps {
  values: Record<string, boolean>;
  onChange: (values: Record<string, boolean>) => void;
  /** Labels the Sub-Unit checkbox, shown when `isSubUnitAllowed` */
  subUnitType?: SubUnitType;
  isSubUnitAllowed: boolean;
}

function VisibilitySection(props: VisibilitySectionProps) {
  const { values, subUnitType, isSubUnitAllowed } = props;

  const handleChange = (e: CheckboxChangeEvent) => {
    const { name } = e.target;
    const { values, onChange } = this.props;
    const newValues = {
      ...values,
      [name!]: !values[name!],
    };

    onChange(newValues);
  };

  return (
    <Flex vertical gap="small" className={styles.filtersContainer}>
      <Checkbox
        name={visibilityFields.AGE}
        checked={values[visibilityFields.AGE]}
        onChange={handleChange}
      >
        <Text strong>
          <FormattedMessage id="advancement.VisibilitySection.age" />
        </Text>
      </Checkbox>
      <Checkbox
        name={visibilityFields.MEMBER_ID}
        checked={values[visibilityFields.MEMBER_ID]}
        onChange={handleChange}
      >
        <Text strong>
          <FormattedMessage id="advancement.VisibilitySection.memberId" />
        </Text>
      </Checkbox>
      <Checkbox
        name={visibilityFields.LAST_RANK_EARNED}
        checked={values[visibilityFields.LAST_RANK_EARNED]}
        onChange={handleChange}
      >
        <Text strong>
          <FormattedMessage id="advancement.VisibilitySection.lastRankEarned" />
        </Text>
      </Checkbox>
      {isSubUnitAllowed && (
        <Checkbox
          name={visibilityFields.SUB_UNIT}
          checked={values[visibilityFields.SUB_UNIT]}
          onChange={handleChange}
        >
          <Text strong>
            <FormattedMessage
              id={`advancement.PackRoster.column.${subUnitType}`}
            />
          </Text>
        </Checkbox>
      )}
    </Flex>
  );
}

export default VisibilitySection;
